'use client';

import { c as _c } from "react/compiler-runtime";
import parking_1 from '@images/renders/architecture_images/desktop/parking_1.webp';
import parking_2 from '@images/renders/architecture_images/desktop/parking_2.webp';
import parkingMob_1 from '@images/renders/architecture_images/mobile/parkingMob_1.webp';
import parkingMob_2 from '@images/renders/architecture_images/mobile/parkingMob_2.webp';
import { SafeHtmlRenderer } from '@lib/tools/helpers/SafeHtmlRenderer';
import { useInView } from '@react-spring/web';
import { useCallback } from 'react';
import ParallaxMedia from '../../parallax-media/ParallaxMedia';
import style from './AboutParking.module.scss';
const data = [{
  subtitle: 'Паркинг 1 очереди',
  description: ['70 машино-мест', '18 кладовых', 'Одноуровневый'],
  img: parking_1,
  imgMob: parkingMob_1,
  id: 1
}, {
  subtitle: 'Паркинг 2 очереди',
  description: ['403 машино-места', '185 кладовых', 'Двухуровневый: <br/>— 1 уровень 195 м/м <br/>— 2 уровень 208 м/м'],
  img: parking_2,
  imgMob: parkingMob_2,
  id: 2
}];
const listData = ['Закрытая подземная отапливаемая стоянка', 'Кладовые для жильцов на&nbsp;этаже паркинга', 'Предусмотрено 10&nbsp;мест с&nbsp;электрозарядкой', 'Въезд в&nbsp;паркинг по&nbsp;системе распознавания автомобильного номера, дистанционного пульта', 'Лифт в&nbsp;паркинг со&nbsp;всех жилых этажей'];
const AboutParking = () => {
  const $ = _c(22);
  const [titleRef, titleInView] = useInView();
  const [bottomRef, bottomInView] = useInView();
  const [cardsRef, cardsInView] = useInView();
  const getView = _temp;
  let t0;
  if ($[0] !== titleInView) {
    t0 = getView(titleInView);
    $[0] = titleInView;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0 || $[3] !== titleRef) {
    t1 = <p className={style.title} ref={titleRef} style={t0}>Паркинг</p>;
    $[2] = t0;
    $[3] = titleRef;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== cardsInView) {
    t2 = getView(cardsInView);
    $[5] = cardsInView;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = data.map(_temp3);
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== cardsRef || $[9] !== t2) {
    t4 = <div className={style.cardsContainer} ref={cardsRef} style={t2}>{t3}</div>;
    $[8] = cardsRef;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== bottomInView) {
    t5 = getView(bottomInView);
    $[11] = bottomInView;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ul className={style.list}>{listData.slice(0, 3).map(_temp4)}</ul>;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ul className={style.list}>{listData.slice(3, 5).map(_temp5)}</ul>;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== bottomRef || $[16] !== t5) {
    t8 = <div className={style.listsGroup} ref={bottomRef} style={t5}>{t6}{t7}</div>;
    $[15] = bottomRef;
    $[16] = t5;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t1 || $[19] !== t4 || $[20] !== t8) {
    t9 = <div className={style.wrapper}>{t1}{t4}{t8}</div>;
    $[18] = t1;
    $[19] = t4;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};
export default AboutParking;
function _temp(view) {
  return {
    opacity: view ? 1 : 0,
    transition: "1s ease",
    position: "relative",
    top: view ? 0 : 80
  };
}
function _temp2(desc, index) {
  const uniqueKey = `${desc.charAt(0)}-${index}`;
  return <SafeHtmlRenderer tag="li" key={uniqueKey} className={style.description__point} content={desc || ""} />;
}
function _temp3(item) {
  return <div key={item.id} className={style.card}><div className={style.imgBox}><ParallaxMedia src={item.img} src375={item.imgMob} imagePlug="" className={style.img} /></div><div className={style.textContent}><SafeHtmlRenderer tag="p" className={style.subtitle} content={item.subtitle || ""} /><ul className={style.description}>{item.description.map(_temp2)}</ul></div></div>;
}
function _temp4(item_0, index_0) {
  const uniqueKey_0 = `${item_0.charAt(0)}-${index_0}`;
  return <SafeHtmlRenderer tag="li" key={uniqueKey_0} content={item_0 || ""} />;
}
function _temp5(item_1, index_1) {
  const uniqueKey_1 = `${item_1.charAt(0)}-${index_1}`;
  return <SafeHtmlRenderer tag="li" key={uniqueKey_1} content={item_1 || ""} />;
}